import styled from '@emotion/styled/macro';
import { BaseNavLink, forTabletPortraitDown, Variables } from '@enter/core';

export interface ICategoryItemProps {
    active?: boolean;
}

export const Link = styled(BaseNavLink)`
    display: inline-flex;
    color: ${Variables.Colors.n100};
`;

export const SettingsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
`;

export const SettingsHeader = styled.div`
    padding: 48px;

    ${forTabletPortraitDown(`
        padding: 12px 24px;
    `)}
`;

export const SettingsArea = styled.div`
    display: flex;
    flex-grow: 1;
    background-color: ${Variables.Colors.white};
    border-top: 1px solid ${Variables.Colors.platinum};

    ${forTabletPortraitDown(`
        flex-wrap: wrap;
    `)}
`;

export const CategoryColumn = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 18rem;
    padding: 20px 50px;
    border-right: 1px solid ${Variables.Colors.platinum};

    ${forTabletPortraitDown(`
        flex-grow: 1;
        padding: 12px 24px;
        width: 100%;
    `)}
`;

export const CategoryHeader = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: ${Variables.Colors.n30};
    padding: 30px 10px 16px 10px;
    white-space: nowrap;
`;

const selectedItem = `
    border-radius: 6px;
    background-color: ${Variables.Colors.p50};
`;

export const CategoryItem = styled.span<ICategoryItemProps>`
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n100};
    padding: 9px 20px;
    white-space: nowrap;
    ${(props: ICategoryItemProps): string | undefined => (props.active ? selectedItem : undefined)}
`;

export const SubCategoryColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    //max-width: 60rem;
    width: 100%;
`;
